module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "role": "modal"
    }
  }, [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "regraFeriasPendentesModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "regraFeriasPendentesModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('botao', {
    attrs: {
      "estilo": "cheio-verde",
      "rotulo": "Ciente",
      "icone": "ok-modal",
      "dismiss": "modal"
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "regraFeriasPendentesModalLabel"
    }
  }, [_vm._v("\n            Férias Anteriores Pendentes\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row row-field",
    staticStyle: {
      "padding-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12"
  }, [_c('p', [_vm._v("Você tem férias pendentes de exercícios anteriores!")]), _vm._v(" "), _c('p', [_vm._v("\n                Conforme § 3º do artigo 172 da Lei nº 4623/84, é proibida a\n                acumulação de férias pelo máximo de dois anos consecutivos.\n              ")]), _vm._v(" "), _c('p', [_vm._v("\n                Para regularizar sua situação é necessário enviar memorando\n                por e-mail para o endereço\n                "), _c('a', {
    attrs: {
      "href": "mailto:ferias@santos.sp.gov.br"
    }
  }, [_vm._v("\n                  ferias@santos.sp.gov.br ")]), _vm._v(", até o 3º dia útil do mês anterior ao do início das férias.\n              ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-be784fe8","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ferias/regra-ferias-pendentes-modal.vue
// module id = LrQo
// module chunks = 5